import { Shadow, SkeletonTypes, HStack, VStack } from '@genial/components';
import { BoxBorder, Spacing } from '@genial/design-tokens';
import { Skeleton } from 'native-base';
import React from 'react';

import { LateralBar } from '../LateralBar';

export const CardLoadingItemMobile: React.FC = () => {
  const ColoredSkeleton = (props: SkeletonTypes.Props) => (
    <Skeleton {...props} endColor="brand.primary.lightest" />
  );

  return (
    <Shadow level={1} borderRadius={BoxBorder.heavy} p="25px">
      <LateralBar
        backgroundColor="brand.primary.lightest"
        borderTopLeftRadius="sm"
        borderBottomLeftRadius="sm"
      />
      <HStack justifyContent="space-between" space={Spacing['inline.quarck']} alignItems="center">
        <VStack space={Spacing['inline.nano']} alignItems="flex-start" flex={1}>
          <ColoredSkeleton width="60%" height="10px" rounded="full" />
          <HStack space={Spacing['inline.xxxs']} alignItems="flex-start" minW="130px">
            <ColoredSkeleton width="45%" height="10px" rounded="full" />
            <ColoredSkeleton width="50%" height="10px" rounded="full" />
          </HStack>
          <HStack space={Spacing['inline.xxxs']} alignItems="flex-start" minW="130px">
            <ColoredSkeleton width="45%" height="10px" rounded="full" />
            <ColoredSkeleton width="50%" height="10px" rounded="full" />
          </HStack>
        </VStack>
        <ColoredSkeleton width="10%" height="20px" rounded="full" />
      </HStack>
    </Shadow>
  );
};
